import styles from "./uploaded-photos-dialog.module.css";
import { useState } from "react";
import { UploadedPhotosGrid } from "./uploaded-photos-grid";
import { DropdownMenu } from "components/common/dropdown-menu";
import { UIIcon } from "PosterEditor/common-components/ui-icon-drawing/ui-icon";

interface UploadedPhotosDialogProps {
  label?: React.ReactNode;
  onClickImage: (url: string) => void;
  /** Controlled visibility state - if provided, component becomes controlled */
  isVisible?: boolean;
  /** Callback when visibility should change - required if isVisible is provided */
  onToggleVisibility?: () => void;
}

export const UploadedPhotosDialog = (props: UploadedPhotosDialogProps) => {
  const [internalVisible, setInternalVisible] = useState(false);

  // Support both controlled and uncontrolled modes
  const isControlled = props.isVisible !== undefined;
  const isVisible = isControlled ? props.isVisible! : internalVisible;
  const toggleVisibility = isControlled
    ? props.onToggleVisibility!
    : () => setInternalVisible((prev) => !prev);

  // When controlled externally, use an empty/hidden label
  const label = isControlled ? (
    <span style={{ display: "none" }} />
  ) : (
    props.label ?? <FallbackLabel isDialogVisible={isVisible ?? false} />
  );

  return (
    <DropdownMenu
      label={label}
      alignment={"left"}
      isVisible={isVisible}
      onToggleVisibility={toggleVisibility}
    >
      <div className={styles.container}>
        <div className={styles.photoGridContainer}>
          <UploadedPhotosGrid
            onLoadURLs={(urls) => {}}
            onClickImage={(url) => {
              toggleVisibility();
              props.onClickImage(url);
            }}
          />
        </div>
      </div>
    </DropdownMenu>
  );
};

interface FallbackLabelProps {
  isDialogVisible: boolean;
}

const FallbackLabel = (props: FallbackLabelProps) => {
  return (
    <button className={styles.uploadedPhotosButton}>
      <p>Choose from uploaded photos</p>
      <UIIcon
        iconName={props.isDialogVisible ? "CHEVRON-UP" : "CHEVRON-DOWN"}
        variant="SELECTED"
        size={16}
      />
    </button>
  );
};
